<curr-modal-popup>
  <div class="orientation-video">
    <iframe
      src="https://www.loom.com/embed/0b529c006b0948c89efaf6ee28c0a970" frameborder="0" webkitallowfullscreen
      mozallowfullscreen allowfullscreen>
    </iframe>
  </div>
  <curr-button class="button" (btnClick)="closeModal()">Got it</curr-button>
</curr-modal-popup>
